import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import baseUrl from '../../../helper/api';

const initialState = {
    isLoading:false,
    status:null,
    error:null
}

export const customerValidateEmail = createAsyncThunk(
    'customer/validateEmail',
    async (data, {rejectWithValue}) => {
        
        const {email, token} = data;
        try{
            
            const response = await axios.get(`${baseUrl}/Account/validateEmailToken?email=${email}&Token=${token}`)
            return response?.data
        } catch (err) {
            
            return rejectWithValue(err.response.data.title)
        }
        
    }
)

const customerValidateEmailSlice = createSlice({
    name:"customer",
    initialState,
    reducers:{},
    extraReducers:{
        [customerValidateEmail.pending]: (state, action) => {
            state.status='pending';
            state.isLoading=true;
        },
        [customerValidateEmail.fulfilled]: (state, action) => {
            state.status='success';
            state.isLoading=false;
            state.data = action.payload;
        },
        [customerValidateEmail.rejected]: (state, action) => {
            state.status='failed';
            state.isLoading=false;
            state.error = action.error
        }
    }
})

export default customerValidateEmailSlice.reducer;